// Locale config now lives in the shared package. This shim keeps
// existing web imports from `@/lib/i18n/config` working unchanged.
export {
  locales,
  localeNames,
  defaultLocale,
  isValidLocale,
} from '@novixone/shared/i18n'
export type { Locale } from '@novixone/shared/i18n'
